<template lang='pug'>
div
    SignalGeneratorSelectorLinks
    div.fullwidth(v-if="$route.params.lang == 'de'")

        div.title-container
            h1.product-title CAL-UHF(-S)
            h2.product-subtitle Kalibrator für UHF-TE-Messung

        div.image-and-highlights-container
            .column-container
                .column.center-content
                    picture.main-product-picture
                        source(type='image/webp', srcset='@/assets/photos/product_shots/CAL-UHF-S.webp')
                        img( src='@/assets/photos/product_shots/CAL-UHF-S.png', width="50%", alt='UHF-TE-Kalibrator CAL-UHF', title='UHF-TE-Kalibrator CAL-UHF')
                .column.factsandbluebox
                    .factbox
                        span.headline Highlights:
                        ul
                            li Referenzsignal für die Kalibrierung von UHF-TE-Messgeräten
                            li Ausgangspegel -70 dBm ... 0 dBm an 50 Ω
                            li Trägerfrequenz 500 MHz
                            li Signallänge 10 ns ... 1000 ns
                            li Verschiedene Triggeroptionen
                            li Wiederaufladbarer Li-Ion-Akku
                            li Steuerbar per LWL
                    .bluebox
                        //- Downloadlink(text='Datenblatt (pdf, deutsch)', link="/pdf/Datenblatt CAL-UHF v2.4.pdf")
                        Downloadlink(text='Datasheet (pdf, english)', link="/pdf/Datasheet CAL-UHF.pdf")
                        Maillink(to='support@bss-hs.de', sub='CAL-UHF', text='Kontakt', size=30, strokeWidth=2)
                        Sitelink(to="/de/products/pdm-600", text='TE-Monitoringsystem PDM-600')
                        Sitelink(to="/de/products/uhfsensors/overview", text='UHF-TE-Sensoren')
                        Sitelink(to="/de/products/pdaccessories/cal-uhf-accessory-kit", text='Zubehörset für CAL-UHF')
                    
        section
            p Signalgenerator zur Erzeugung von Referenzsignalen mit definiertem Pegel für die Kalibrierung von UHF-Teilentladungsmessgeräten gemäß Cigré TB 861. 
            p Das Ausgangssignal kann per TTL-Signal, durch eine Fotodiode, durch einen manuellen Triggerknopf oder durch Fernsteuerung per LWL getriggert werden. Außerdem kann er auf eine feste Wiederholrate mit internem Takt eingestellt werden. Der Impulsgenerator wird mit einem Lithium-Ionen-Akku betrieben und kann bei Bedarf komplett per LWL ferngesteuert werden.

        section
            h4 Signal im Zeitbereich
            .column-container
                .column.align-top
                    picture.main-product-picture
                        source(type='image/avif', srcset='@/assets/photos/CAL-UHF_Impulse.avif')
                        source(type='image/webp', srcset='@/assets/photos/CAL-UHF_Impulse.webp')
                        img( src='@/assets/photos/CAL-UHF_Impulse.png', width="80%", alt='CAL-UHF Signalform im Zeitbereich', title='CAL-UHF Signalform im Zeitbereich')
                .column.align-top
                    p Gemessen mit einem DSO mit:
                    ul
                        li 4&nbsp;GHz Analogbandbreite
                        li 40&nbsp;GS/s Sampling-Rate
                        li 8&nbsp;bit vertikale Auflösung

        //- section
        //-     h4 Maße und Ports
        //-     picture.main-product-picture
        //-         source(type='image/avif', srcset='@/assets/extras/CAL-UHF_Vektor_Maße_Ports.avif')
        //-         source(type='image/webp', srcset='@/assets/extras/CAL-UHF_Vektor_Maße_Ports.webp')
        //-         img( src='@/assets/extras/CAL-UHF_Vektor_Maße_Ports.png', width="100%", alt='BSS CAL-UHF Calibrator Measurements and Ports', title='CAL-UHF Measurements and Ports')





    div.fullwidth(v-if="$route.params.lang == 'en'")

        div.title-container
            h1.product-title CAL-UHF(-S)
            h2.product-subtitle Calibrator for UHF PD Measurement

        div.margin-bottom
            .column-container
                .column.center-content
                    picture.main-product-picture
                        source(type='image/webp', srcset='@/assets/photos/product_shots/CAL-UHF-S.webp')
                        img( src='@/assets/photos/product_shots/CAL-UHF-S.png', width="50%", alt='UHF PD Calibrator CAL-UHF', title='UHF PD Calibrator CAL-UHF')
                    
                .column.factsandbluebox
                    .factbox
                        span.headline Key Features:
                        ul
                            li Reference signal for the calibration of UHF PD measurement devices
                            li Output range -70 dBm … 0 dBm at 50 Ω
                            li Carrier frequency 500 MHz
                            li Signal length 10 ns ... 1000 ns
                            li Various trigger options
                            li Controllable via fiber optic link
                            li Battery powered
                    .bluebox
                        //- Downloadlink(text='Datenblatt (pdf, deutsch)', link="/pdf/Datenblatt CAL-UHF v2.4.pdf")
                        Downloadlink(text='Datasheet (pdf, english)', link="/pdf/Datasheet CAL-UHF.pdf")
                        Maillink(to='support@bss-hs.de', sub='CAL-UHF', text='Contact Us', size=30, strokeWidth=2)
                        Sitelink(to="/en/products/pdm-600", text='PD Monitoring System PDM-600')
                        Sitelink(to="/en/products/uhfsensors/overview", text='UHF PD Sensors')
                        Sitelink(to="/en/products/pdaccessories/cal-uhf-accessory-kit", text='CAL-UHF Accessory Kit')
                    
        section
            p Reference signal generator with a defined level for the calibration of UHF partial discharge measuring instruments according to Cigré TB 861.
            p The signal can be triggered by a TTL signal, by a photodiode, by a manual trigger button and by the remote control via fiber optic (FO) cable. In addition, it can be set to a fixed repetition rate per internal clock. The pulse generator is operated by lithium-ion battery and can be controlled remotely by FO if required.

        section
            h4 Signal shape in time domain
            .column-container
                .column.align-top
                    picture.main-product-picture
                        source(type='image/avif', srcset='@/assets/photos/CAL-UHF_Impulse.avif')
                        source(type='image/webp', srcset='@/assets/photos/CAL-UHF_Impulse.webp')
                        img( src='@/assets/photos/CAL-UHF_Impulse.png', width="80%", alt='CAL-UHF Signalform im Zeitbereich', title='CAL-UHF Signalform im Zeitbereich')
                .column.align-top
                    p measured using a DSO with
                    ul
                        li 4&nbsp;GHz analog bandwidth
                        li 40&nbsp;GS/s sampling rate
                        li 8&nbsp;bit vertical resolution

        //- section
        //-     h4 Dimensions and Ports
        //-     picture.main-product-picture
        //-         source(type='image/avif', srcset='@/assets/extras/CAL-UHF_Vektor_Maße_Ports.avif')
        //-         source(type='image/webp', srcset='@/assets/extras/CAL-UHF_Vektor_Maße_Ports.webp')
        //-         img( src='@/assets/extras/CAL-UHF_Vektor_Maße_Ports.png', width="100%", alt='BSS CAL-UHF Calibrator Measurements and Ports', title='CAL-UHF Measurements and Ports')

</template>

<script>
export default {
    meta: {
        de: {
            title: "BSS | CAL-UHF",
            description:
                "UHF-Teilentladungskalibrator",
        },
        en: {
            title: "BSS | CAL-UHF",
            description:
                "UHF Partial Discharge Calibrator",
        },
    },
};
</script>